//Functions for validate inputs
export default class Validate {
  static verifyEmpty = (value) => {
    return value.length != 0;
  };

  static verifyDNI = (value) => {
    let regex = /^[0-9]*$/;
    while (value != undefined) {
      return !regex.test(value) || value.length != 8 ? false : true;
    }
  };
  static verifyCE = (value) => {
	  while (value != undefined) {
		  return (value.length != 0 && value.length >= 9);
	  }
  };

  static verifyRUC = (value) => {
    let regex = /^[0-9]*$/;
    while (value != undefined) {
      return !regex.test(value) || value.length != 11 || (value.substring(0, 2) != '20' && value.substring(0, 2) != '10') ? false : true;
    }
  };

  static verifyPhone = (value) => {
    let regex = /^[0-9]*$/;
    while (value != undefined) {
      return !regex.test(value) || value.length != 9 || value.charAt(0) != 9 ? false : true;
    }
  };

  static verifyDocument = (value) => {
    return value.length >= 8;
  }

  static verifyAddress = (value) => {
    if (!value) {
      return false;
    }
    return value.length >= 3;
  }

  static verifyEmpty = (value) => {
    return value.length > 0;
  }

  static verifyEmail = (value) => {
    const regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
    while (value != undefined) {
      return !regexEmail.test(value) ? false : true;
    }
  };

  static validateEmail(email) {
    let tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
    if (!email) return false;
    let emailParts = email.split('@');
    if (emailParts.length !== 2) return false;
    let account = emailParts[0];
    let address = emailParts[1];
    if (account.length > 64) return false;
    else if (address.length > 255) return false;
    let domainParts = address.split('.');
    if (domainParts.some(function (part) {
      return part.length > 63;
    })) return false;
    return tester.test(email);
  };

  static verifyLetters = (val) => {
    //let regex = /^[a-zA-ZÀ-ÿ\u00f1\u00d1\u0027]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1\u0027]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\u0027]+$/g;
    let regex = /^([a-zA-ZÀ-ÿ_ ]+\s)*[a-zA-ZÀ-ÿ_ ]*$/;
    return val.length != 0 ? regex.test(val) : false;
  };

  static verifyDate = (value) => {
    // let regex = /^[0-9]*$/;
    while (value != undefined) {
      return value.length != 0 ? false : true;
    }
  };

	static verifyHeight = (value) => {
		const height = /(^[0-2]{1})+[.]+([0-9]{2})?$/;
		while(value != undefined){
			return  !((!height.test(value)) || (Number(value) === 0));
		}
  }

  static validateUniversityInsurance = () => sessionStorage.getItem('version') === "universitario";
}
